import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AnimakitExpander from "animakit-expander";
import classes from './Addons.scss';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import AddonsHeader from './AddonsHeader/AddonsHeader';
// import Insurance from './Insurance/Insurance';
import GST from './GST/GST';
import Extras from './Extras/Extras';
import Meals from './Meals/Meals';
import Seats from './Seats/Seats';
import Baggage from './Baggage/Baggage';

import HeadingH3 from '../UI/Headings/HeadingH3/HeadingH3';
import MobileBackButton from '../UI/Mobile/MobileBackButton/MobileBackButton';

import Media from 'react-media';

const review = (props) => {
        return (
            <div className={classes.Container}>
                <Media query="(max-width: 599px)">
                    {matches => 
                        matches ? <div className={`${classes.MobileHeader} u-flex justify-content-center align-items-center u-backgroundColorWhite pl-2 pr-2 pt-4 pb-4`}>
                            <MobileBackButton onClick={() => props.history.push({
                                pathname: "/reviews/details",
                                search: props.location.search 
                            })}/>
                        <div className={'mx-auto'}>
                            <HeadingH3 size={16} weight="Medium" color="Dark">Add-Ons for you</HeadingH3>
                        </div>
                    </div> : null
                    }
                </Media>
                <div className={`phone-pt-4`}>
                    {props.showGST ? (
                        <section className={`mb-3`}>
                            <GST />
                        </section>
                    ) : null}
                    {/* {
                        props.showTravelInsurance ? (
                            <section className={`mb-3`}>
                                <Insurance/>
                            </section>
                        ) : null
                    } */}
                    <section className={`mb-3 u-relative u-boxShadowNormal`}>
                        <div className={classes.Wrapper}>
                            <div>
                                <ReactCSSTransitionGroup
                                component={this.FirstChild}
                                transitionName="opacity"
                                transitionAppear={true}
                                transitionEnter={true}
                                transitionLeave={true}
                                transitionEnterTimeout={500}
                                transitionLeaveTimeout={300}
                                transitionAppearTimeout={500}>
                                    {props.addonsExpanded ? <AddonsHeader/> : <Extras view={props.addonsView}/>}
                            </ReactCSSTransitionGroup>
                            </div>
                        </div>
                        <AnimakitExpander
                            expanded={props.addonsExpanded}
                            align="bottom">
                            {
                                props.addonsView === 'seats' ? 
                                <Seats /> : props.addonsView === 'meals' ? 
                                <Meals /> : props.addonsView === 'baggage' ? 
                                <Baggage /> : null
                            }
                        </AnimakitExpander>
                    </section>
                </div>
            </div>
        );
}

const mapStateToProps = state => {
    return {
        addonsView: state.ui.addonsView,
        addonsExpanded: state.ui.addonsExpanded,
        ycp: state.farePrice.fareSummaryOneWay.ADT.dfc || -1,
        addonList: state.farePrice.addonList,
        // showTravelInsurance: state.farePrice.showTravellerInsurance,
        showGST: state.farePrice.generalData.data.showGst,
        isSDFC: state.farePrice.isSDFC,
        isBBG: state.farePrice.isBBG
    }
}

export default withRouter(connect(mapStateToProps)(review));


// WEBPACK FOOTER //
// ./src/components/Addons/Addons.js